import { render } from "./StdSpinner.vue?vue&type=template&id=9a44b9b2"
import script from "./StdSpinner.vue?vue&type=script&lang=js"
export * from "./StdSpinner.vue?vue&type=script&lang=js"

import "./StdSpinner.vue?vue&type=style&index=0&id=9a44b9b2&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__